import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { COLORS, RADIUS, FONT } from '../shared/tokens';
import { COL_HEAD } from '../shared/txStyles';

/* Titled card wrapping an MUI table.
   columns = [{ key, label, align?, render?(row) }]. If `accent`/`count` are set,
   the header shows a status dot + count pill (matching the old job-table look). */
export default function TableCard({ title, accent, count, columns, rows = [], emptyLabel = 'No records', flex = '1 1 100%', maxHeight = 320 }) {
    return (
        <div style={{
            flex, minWidth: 0, boxSizing: 'border-box',
            background: COLORS.surface, border: `1px solid ${COLORS.border}`,
            borderRadius: RADIUS.card, overflow: 'hidden',
        }}>
            <div style={{ padding: '14px 18px', borderBottom: `1px solid ${COLORS.border}`, display: 'flex', alignItems: 'center', gap: 10 }}>
                {accent && <span style={{ width: 8, height: 8, borderRadius: '50%', background: accent, flexShrink: 0 }} />}
                <span style={{ fontFamily: FONT, fontSize: 14, fontWeight: 700, color: COLORS.text }}>{title}</span>
                {count != null && (
                    <span style={{
                        marginLeft: 'auto', fontFamily: FONT, fontSize: 11, fontWeight: 700,
                        background: `${accent || COLORS.primary}18`, color: accent || COLORS.primary,
                        border: `1px solid ${accent || COLORS.primary}33`, borderRadius: 20, padding: '2px 10px',
                    }}>
                        {count}
                    </span>
                )}
            </div>
            <div style={{ overflowY: 'auto', maxHeight }}>
                <Table size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            {columns.map((c) => (
                                <TableCell key={c.key} align={c.align || 'left'} sx={{ ...COL_HEAD, position: 'sticky', top: 0 }}>
                                    {c.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={columns.length} sx={{ color: COLORS.placeholder, fontFamily: FONT, fontSize: 12, textAlign: 'center', padding: '26px', borderBottom: 'none' }}>
                                    {emptyLabel}
                                </TableCell>
                            </TableRow>
                        ) : rows.map((row, ri) => (
                            <TableRow key={ri} sx={{ '&:hover': { background: COLORS.primaryTintSoft }, '&:last-child td': { borderBottom: 'none' } }}>
                                {columns.map((c) => (
                                    <TableCell key={c.key} align={c.align || 'left'} sx={{
                                        fontFamily: FONT, fontSize: 13, color: COLORS.text,
                                        borderBottom: `1px solid ${COLORS.border}`, padding: '9px 16px', whiteSpace: 'nowrap',
                                    }}>
                                        {c.render ? c.render(row) : row[c.key]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}
